/* BeyTik Pro — Scroll reveal, staggered cards, header & micro-interactions */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;

  /* =========================================================
     SCROLL REVEAL ENGINE (safe: only hides when JS can reveal)
     ========================================================= */
  if (!reduce) {
    document.documentElement.classList.add('bt-animate-ready');

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bt-rv-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });

    function staggerGrid(grid) {
      if (grid.classList.contains('bt-stagger')) return;
      grid.classList.add('bt-stagger');
      var kids = grid.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].style.setProperty('--bt-i', i % 12);
      }
      revealObserver.observe(grid);
    }

    function markReveal() {
      // 1. Reveal each homepage / page section as it scrolls into view
      document.querySelectorAll('#MainContent .shopify-section').forEach(function (sec) {
        if (sec.classList.contains('bt-rv') || sec.dataset.btSkip === '1') return;
        sec.classList.add('bt-rv');
        revealObserver.observe(sec);
      });

      // 2. Stagger product cards inside BeyTik hub / product grids
      document.querySelectorAll('.bt-hub-grid, .bt-pg-grid').forEach(staggerGrid);

      // 3. Stagger native collection / search grids — but ONLY when Dawn's own
      //    scroll animation isn't already handling the items (avoids double-animating)
      document.querySelectorAll('.product-grid').forEach(function (grid) {
        if (grid.querySelector('.grid__item.scroll-trigger')) return;
        staggerGrid(grid);
      });
    }
    markReveal();

    // Re-scan when sections are added/reordered in the theme editor
    if (inEditor) {
      document.addEventListener('shopify:section:load', markReveal);
      document.addEventListener('shopify:section:reorder', markReveal);
    }

    // FAILSAFE: never leave content hidden if an observer misfires
    setTimeout(function () {
      document.querySelectorAll('.bt-rv:not(.bt-rv-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight + 200) el.classList.add('bt-rv-in');
      });
    }, 1400);
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.bt-rv:not(.bt-rv-in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight) el.classList.add('bt-rv-in');
        });
      }, 300);
    });
  }

  /* === Legacy data-attribute reveal (kept for any manual markup) === */
  if (!reduce) {
    var legacy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bt-revealed'); legacy.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-bt-reveal]').forEach(function (el) { legacy.observe(el); });
  }

  /* === HEADER condense on scroll === */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var lastY = -1;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y === lastY) return;
      lastY = y;
      if (y > 60) header.classList.add('scrolled'); else header.classList.remove('scrolled');
    }, { passive: true });
  }

  /* === SMOOTH anchor scrolling === */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    });
  });

  /* === LAZY image fade-in === */
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    if (img.dataset.btFade) return;
    img.dataset.btFade = '1';
    if (img.complete) { img.style.opacity = '1'; return; }
    img.style.opacity = '0';
    img.style.transition = 'opacity 0.5s ease';
    img.addEventListener('load', function () { this.style.opacity = '1'; });
    img.addEventListener('error', function () { this.style.opacity = '1'; });
  });

  /* === SHINE sweep on primary buttons === */
  document.querySelectorAll('.bt-btn-primary, .button--primary, .product-form__submit, .bt-hub-va').forEach(function (b) {
    b.classList.add('bt-shine');
  });

  /* === COUNT-UP for any [data-count] element === */
  function animateCounter(el, end) {
    var duration = 1700, startTime = null, suffix = el.dataset.suffix || '';
    function step(ts) {
      if (!startTime) startTime = ts;
      var p = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(eased * end).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if (!reduce) {
    var counters = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var v = parseInt(entry.target.dataset.count, 10);
          if (!isNaN(v)) animateCounter(entry.target, v);
          counters.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-count]').forEach(function (el) { counters.observe(el); });
  }
})();
